import React from "react";
import styles from "./ConnectionStatusBanner.module.css";

type ConnectionStatus =
  | "connected"
  | "connecting"
  | "disconnected"
  | "unauthenticated";

interface ConnectionStatusBannerProps {
  connectionStatus: ConnectionStatus;
}

const ConnectionStatusBanner = ({
  connectionStatus,
}: ConnectionStatusBannerProps): React.ReactElement | null => {
  if (connectionStatus === "connected") {
    return null;
  }

  return (
    <p className={styles["connection-status-banner"]}>
      {connectionStatus === "connecting" &&
        "Connecting to live pass updates..."}
      {connectionStatus === "disconnected" &&
        "Disconnected from live pass updates - reconnecting..."}
      {connectionStatus === "unauthenticated" &&
        "Unable to authenticate live pass updates. Please refresh the page."}
    </p>
  );
};

export default ConnectionStatusBanner;
